import { render, staticRenderFns } from "./PropertyPanel.vue?vue&type=template&id=6e2bc2e7&scoped=true"
import script from "./PropertyPanel.vue?vue&type=script&lang=js"
export * from "./PropertyPanel.vue?vue&type=script&lang=js"
import style0 from "./PropertyPanel.vue?vue&type=style&index=0&id=6e2bc2e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2bc2e7",
  null
  
)

export default component.exports